import React, { ReactElement } from 'react';

import { PackageSearch } from 'leash/components/packageSearch/PackageSearch';
import NavigationMenu from 'leash/components/navigationMenu/NavigationMenu';

function NavigationCenterTools(): ReactElement {
  return (
    <>
      <NavigationMenu />
      <PackageSearch />
    </>
  );
}

export default NavigationCenterTools;
